import { render } from "./QuestionThreeScreen.vue?vue&type=template&id=15546054&scoped=true&lang=html"
import script from "./QuestionThreeScreen.vue?vue&type=script&lang=js"
export * from "./QuestionThreeScreen.vue?vue&type=script&lang=js"

import "./QuestionThreeScreen.vue?vue&type=style&index=0&id=15546054&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_rodi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15546054"]])

export default __exports__